<template>
  <div class="vehicle-panel">
    <div class="header">
      <v-row class="no-padding">
        <v-col
          cols="auto"
          class="mr-auto"
        >
         <span>Install Tags</span>
        </v-col>
      </v-row>
    </div>
    <div class="content">
      <v-list dense>
        <v-list-item-group
          v-model="selection"
          multiple
          color="primary"
        >
          <v-list-item
            v-for="(item, i) in selectedDevices"
            :key="i"
          >
            <v-list-item-content>
              <v-list-item-title v-text="item.install_tag"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstallTags',
  props: {
    selectedDevices: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selection: []
    }
  },
  watch: {
    selection(val) {
      this.$emit('deviceSelectedForInstall', val);
    }
  },
  mounted() {
    window.EventBus.$on("resetDeviceSelection", this.resetSelection);
  },
  methods: {
    resetSelection() {
      this.selection = [];
    }
  }
}
</script>

<style lang="scss" scoped>
  .vehicle-panel {
    height: 100%;
    background: white;
    border: solid 1px black;
    margin-left: 1em;
    .header {
      background: #e0e0e0;
    }
    .content {
      height: 650px;
      padding: 0.5em .75em;
      overflow: scroll;
    }
  }
  .no-padding {
    padding: 0 !important;
    margin: 0 !important;
  }
</style>